















import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  computed: {
    donutSeries(): number[] {
      return [
        this.$store.getters.badFileSizeList.length,
        this.$store.getters.totalDataNumber -
          this.$store.getters.badFileSizeList.length,
      ];
    },
    histSeries(): [{ name: string; data: Array<number> }] {
      const histBars = this.$store.getters.fileSizeDistribution.bars;

      return [
        {
          name: `Count`,
          data: Object.values(histBars),
        },
      ];
    },
    histChartOptions(): ApexOptions {
      const histBars = this.$store.getters.fileSizeDistribution.bars;
      return {
        colors: ['#24BE99'],
        chart: {
          toolbar: {
            show: false,
          },
          offsetY: 0,
        },
        xaxis: {
          type: 'category',
          categories: Object.keys(histBars),
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          textAnchor: 'middle',
          enabled: false,
        },
        noData: {
          text: '모든 데이터가 파일 크기 기준을 만족합니다',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '20px',
            fontFamily: 'Noto Sans KR',
          },
        },
      };
    },
  },
  data(): {
    donutLabels: string[];
    donutColors: string[];
  } {
    return {
      donutLabels: ['준수', '미준수'],
      donutColors: ['#24BE99', '#F8791D'],
    };
  },
});
